import { createImmutableObjectClass } from 'immutable-less/ImmutableObject';
import produce from 'immer';
import ActionConfigBasePaths from 'automation-ui-action-features/actions/ActionConfigBasePaths';
import { NEW_ACTION } from 'automation-ui-flow-core/canvas/SpecialActionIds';
import HubSpotDefinedActionSuggestions from 'automation-ui-action-features/components/suggestions/HubSpotDefinedActionSuggestions';
import * as ActionTypes from 'automation-ui-canvas/actions/ActionTypes';
class ActionPanelState extends createImmutableObjectClass({
  suggestionGroup: null,
  queuedAction: null
}) {}
export const initialState = new ActionPanelState();
export default ((state = initialState, action) => produce(state, newState => {
  switch (action.type) {
    case ActionTypes.ACTION_PANEL_SET_SELECTED_ACTION_SUGGESTION:
      {
        const {
          suggestionId,
          selected
        } = action.payload;
        const suggestion = newState.suggestionGroup.suggestions.get(suggestionId);
        suggestion.selected = selected;
        break;
      }
    case ActionTypes.ACTION_PANEL_SET_QUEUED_ACTION:
      {
        newState.queuedAction = action.payload;
        break;
      }
    case ActionTypes.ACTION_PANEL_RESET_SUGGESTIONS:
      {
        const {
          actionId,
          actionTypeBasePath,
          visibility
        } = action.payload;
        const {
          queuedAction
        } = newState;
        const [actionType] = Object.entries(ActionConfigBasePaths).find(([, basePath]) => basePath === actionTypeBasePath) || [];
        const isConfiguringNewAction = actionId === NEW_ACTION;

        // reset the suggestions after switching actions or closing the panel
        const suggestionGroup = HubSpotDefinedActionSuggestions.get(actionType);
        if (isConfiguringNewAction && suggestionGroup && suggestionGroup.shouldAppear(visibility)) {
          newState.suggestionGroup = suggestionGroup;
        } else {
          newState.suggestionGroup = null;
        }

        // clear the queued, suggested action only if we abandon that action
        const isConfiguringSuggestedAction = isConfiguringNewAction && queuedAction !== null && actionType === queuedAction.action.getActionType();
        if (!isConfiguringSuggestedAction) {
          newState.queuedAction = null;
        }
        break;
      }
    default:
  }
}));